export class BasicParallelEnumerable {
    dataFunc;
    constructor(dataFunc) {
        this.dataFunc = dataFunc;
    }
    [Symbol.asyncIterator]() {
        const { dataFunc } = this;
        async function* iterator() {
            switch (dataFunc.type) {
                case 1:
                    for (const value of dataFunc.generator()) {
                        yield value;
                    }
                    break;
                case 2:
                    for (const value of await dataFunc.generator()) {
                        yield value;
                    }
                    break;
                case 0:
                default:
                    for (const value of await dataFunc.generator()) {
                        yield value;
                    }
                    break;
            }
        }
        return iterator();
    }
}
